



















import { Component, Prop, Vue } from 'vue-property-decorator';
import DialogBox from '@/components/dialog-box/DialogBox.vue';

@Component({
  components : { DialogBox }
})
export default class MoreActionsDialog extends Vue {
  @Prop({ default: false }) isDialogOpen: boolean;

  substitution() {
    this.$emit('substition');
  }

  outOfStock() {
    this.$emit('outOfStock');
  }

  back() {
    this.$emit('back');
  }
}
